<div class="app-container offset-md-3 col-md-6">
  <div class="card-error contentBody p-4 m-1">
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <h3 id="error-title">{{ app.getText("error.headerMessage") }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-3 text-center">
        <p id="error-message">
          {{ app.getText("error.subtitleMessageL1") }}
        </p>
        <p id="error-message">
          {{ app.getText("error.subtitleMessageL2") }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 mt-3 text-center">
                <p>{{ getMessage() }}</p>
                @if (tenantId) {
                  <p>Tenant ID: {{ tenantId }}</p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row centerRow">
      <div class="col-md-6 mt-4">
        <button (click)="goBack()" class="sendEmailBtn no-border">
          <i class="fa-solid fa-arrow-left"></i>
          {{ app.getText("error.goBackButton") }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="app-footer">
  <app-footer></app-footer>
</div>
